export interface IBarcodeService {
  generateBarcode(data: string): Promise<string>;
  validateBarcode(barcode: string): boolean;
  parseBarcode(barcode: string): { type: string; data: string };
}

export class BarcodeService implements IBarcodeService {
  // We'll support common barcode formats like EAN-13, UPC-A, Code128
  private readonly BARCODE_PATTERNS = {
    EAN13: /^[0-9]{13}$/,
    UPCA: /^[0-9]{12}$/,
    CODE128: /^[A-Z0-9-_\s]{1,48}$/i,
  };

  async generateBarcode(data: string): Promise<string> {
    // In a real implementation, this would use a barcode generation library
    // For now, we'll just validate and format the input
    if (this.validateBarcode(data)) {
      return data;
    }
    
    // If the input doesn't match any format, we'll create a CODE128 compatible string
    const sanitized = data
      .replace(/[^A-Z0-9-_\s]/gi, '') // Remove invalid characters
      .substring(0, 48);              // Truncate to max length
    
    return sanitized;
  }

  validateBarcode(barcode: string): boolean {
    return Object.values(this.BARCODE_PATTERNS).some(pattern => 
      pattern.test(barcode)
    );
  }

  parseBarcode(barcode: string): { type: string; data: string } {
    for (const [type, pattern] of Object.entries(this.BARCODE_PATTERNS)) {
      if (pattern.test(barcode)) {
        return { type, data: barcode };
      }
    }
    throw new Error('Invalid barcode format');
  }
}